import { gql } from '@apollo/client';

export const JOB_NOTIFICATION_DEFERMENT_QUERY = gql`
  query userJobNotificationDeferment (
    $jobId: Int!
  ) {
      userJobNotificationDeferment (
       jobId: $jobId
      ) {
        deferFrom
        deferUntil
      }
  }
`;
